module.exports = __webpack_public_path__ + "img/bg.2e799864.png";